import { Address } from '@/assets/entities';

export const formatAddress = (a: Address) => `${a.street} ${a.number}${a.floor ? `, ${a.floor}` : ''}${a.apartment ? a.apartment : ''}`;
